import * as React from "react";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";

export interface SimpleColumnDef {
    field: string,
    headerName: string,
    width: number | string,
    cellStyle?: string,
    valueFormatter?: ValueFormatterFunction
}

export interface ValueFormatterFunction {
    (data: any): ValueFormatterResult | undefined;
}

export interface ValueFormatterResult {
    component?: any;
}


function InvoiceSimpleTable(props: { columnDefs: SimpleColumnDef[], data: any[] }) {

    const getHeaderStyle = (width: string | number, cellStyle: any|undefined) => {
        return {
            borderBottom: 'none', fontWeight: 600, width: `${width}`, fontSize: "1rem", textAlign:  `${cellStyle}`
        }
    };

    const getRowStyle = (width: string | number) => {
        return {
            borderBottom: 'none', fontWeight: 400, width: `${width}`, fontSize: "1rem"
        }
    };

    function resolve(path: string, obj: any) {
        return path.split('.').reduce(function (prev: any, curr: any) {
            return prev ? prev[curr] : null
        }, obj)
    }

    return (
            <TableContainer>
                <Table>
                    <TableHead>
                        <TableRow sx={{ fontSize: "1rem" }}>
                            {props.columnDefs.map((it, index) => {
                                return (
                                        <TableCell key={index} component={"th"} sx={getHeaderStyle(it.width, it.cellStyle)}>
                                            {it.headerName}
                                        </TableCell>
                                )
                            })}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {props.data.map((it: any, rowIndex) => {
                            return (
                                    <TableRow key={rowIndex}>
                                        {props.columnDefs.map((column, index) => {
                                            let value = resolve(column.field, it);

                                            return (
                                                    <TableCell key={index} component={"td"} sx={getRowStyle(column.width)}>
                                                        {column.valueFormatter ? column.valueFormatter(it)?.component() : value}
                                                    </TableCell>
                                            );
                                        })}
                                    </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
    )
}

export default InvoiceSimpleTable;